var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F3BA2F",
    d: "M9.79 13.45 16 7.23l6.22 6.22 3.61-3.62L16 0 6.17 9.83l3.62 3.62ZM0 16l3.62-3.62L7.23 16l-3.61 3.62L0 16Zm9.79 2.55L16 24.77l6.22-6.22 3.62 3.61L16 32l-9.83-9.83 3.62-3.62ZM24.77 16l3.61-3.62L32 16l-3.62 3.62L24.77 16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3BA2F",
    d: "M19.67 16 16 12.33l-2.71 2.71-.31.31-.64.64-.01.01L16 19.67 19.67 16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.f72a999336086dadb3c65594fd88a4e6.svg";
export { ForwardRef as ReactComponent };